import { c as _c } from "react/compiler-runtime";
import { Box, Divider, IconButton, Stack, Typography } from '@mui/material';
import classnames from 'classnames';
import { getTestId } from './panelTestId';
export interface PanelHeaderProps {
  onClose?: () => void;
  onBack?: () => void;
  hideBorder?: boolean;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  alignTitles?: boolean;
  testIdPrefix?: string;
  fullWidthSubtitle?: boolean;
}
export const PanelHeader = props => {
  const $ = _c(31);
  const {
    title,
    subtitle,
    actions,
    testIdPrefix,
    onClose,
    onBack,
    hideBorder,
    alignTitles,
    fullWidthSubtitle: t0
  } = props;
  const fullWidthSubtitle = t0 === undefined ? true : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px 24px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      gap: "12px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onBack) {
    t3 = onBack && <IconButton data-testid="header-back-button" onClick={onBack} sx={{
      color: "var(--mui-palette-text-primary)"
    }}><i className="material-symbols-chevron-left-rounded" /></IconButton>;
    $[2] = onBack;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== testIdPrefix || $[5] !== title) {
    t4 = typeof title === "string" ? <Typography variant="h3" data-testid={getTestId(testIdPrefix, "side-panel-title")}>{title}</Typography> : title;
    $[4] = testIdPrefix;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Stack className="flex-1">{t4}</Stack>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <Stack direction="row" className="flex-1" sx={t2}>{t3}{t5}</Stack>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onClose || $[13] !== testIdPrefix) {
    t7 = onClose && <IconButton onClick={onClose} data-testid={getTestId(testIdPrefix, "side-panel-close-button")} sx={{
      color: "var(--mui-palette-text-primary)"
    }}><i className="material-symbols-close-rounded" /></IconButton>;
    $[12] = onClose;
    $[13] = testIdPrefix;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== actions || $[16] !== t7) {
    t8 = <div className="flex gap-4 items-center">{actions}{t7}</div>;
    $[15] = actions;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <Stack direction="row" sx={t1}>{t6}{t8}</Stack>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== alignTitles || $[22] !== fullWidthSubtitle || $[23] !== subtitle) {
    t10 = subtitle && <Box className={classnames([{
      "ml-[24px]": alignTitles,
      "ml-[40px]": !alignTitles,
      "max-w-[580px]": !fullWidthSubtitle
    }, "mb-[20px] mt-[8px] mr-[24px]"])}>{typeof subtitle === "string" ? <Typography variant="body1">{subtitle}</Typography> : subtitle}</Box>;
    $[21] = alignTitles;
    $[22] = fullWidthSubtitle;
    $[23] = subtitle;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== hideBorder) {
    t11 = !hideBorder && <Divider />;
    $[25] = hideBorder;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t9) {
    t12 = <Stack>{t9}{t10}{t11}</Stack>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};